import * as angular from 'angular';

import View from '../../model/view';

/**
 * @ngdoc service
 * @name mx.shell.InfoPanelService
 * @module mx.shell
 * @requires {@ref mx.shell.View}
 *
 * @description
 * A service that is used for configuration of info-panel, add/remove widgets from info-panel
 */
export class MxShellInfoPanelService {
	public readonly widgets: View[] = [];

	/**
	 * @ngdoc method
	 * @name mx.shell.InfoPanelService#addWidget
	 *
	 * @param {View} widget - new widget to add into the info-panel
	 *
	 * @description
	 * Add new widget into info-panel
	 *
	 * @returns {Boolean} Return true if the widget was added into the panel
	 */
	public addWidget(widget: View): boolean {
		if (widget instanceof View && this.widgets.indexOf(widget) < 0) {
			this.widgets.push(widget);
			return true;
		}
		return false;
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.InfoPanelService#removeWidget
	 *
	 * @param {View} widget - widget to remove from the info-panel
	 *
	 * @description
	 * Remove some widget from the info-panel
	 *
	 * @returns {Boolean} Return true if the widget was removed from the panel
	 */
	public removeWidget(widget: View): boolean {
		const index = this.widgets.indexOf(widget);
		if (index >= 0) {
			this.widgets.splice(index, 1);
			return true;
		}
		return false;
	}
}

angular.module('mx.shell').service('mx.shell.InfoPanelService', MxShellInfoPanelService);
